import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import { Table, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";

const BlogListPage = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  const token = localStorage.getItem("token");

  const fetchBlogs = async () => {
    const res = await api.get("/blogs");
    setBlogs(res.data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const deleteBlog = async (id) => {
    if (!window.confirm("Bu blog silinsin mi?")) return;

    await api.delete(`/blogs/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    fetchBlogs();
  };

  return (
    <AdminLayout>
      <Card className="p-4 shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 style={{ color: "#2D8A7A" }}>Blog Yönetimi</h3>
          <Button className="btn-primary" onClick={() => navigate("/admin/blogs/add")}>
            Yeni Blog Ekle
          </Button>
        </div>

        <Table hover responsive>
          <thead>
            <tr>
              <th>Başlık</th>
              <th>Tarih</th>
              <th style={{ width: "160px" }}>İşlemler</th>
            </tr>
          </thead>

          <tbody>
            {blogs.map((blog) => (
              <tr key={blog._id}>
                <td>{blog.title}</td>
                <td>{new Date(blog.createdAt).toLocaleDateString("tr-TR")}</td>
                <td>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="me-2"
                    onClick={() => navigate(`/admin/blogs/edit/${blog._id}`)}
                  >
                    Düzenle
                  </Button>

                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => deleteBlog(blog._id)}
                  >
                    Sil
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </AdminLayout>
  );
};

export default BlogListPage;
